import { gql } from "@apollo/client"

export const GET_LICENSE_STATISTICS = gql`
  query getLicenseStatistics($data: GetLicenseStatisticsInput!) {
    licensePool {
      getLicenseStatistics(data: $data) {
        totalSeats
        assignedSeats
        availableSeats
        activePoolsCount
        totalStudents
        assignedStudents
        unassignedStudents
        studentsBySchool {
          schoolId
          schoolName
          totalStudents
          assignedStudents
          unassignedStudents
        }
      }
    }
  }
`
